import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators'
import { Subject } from 'rxjs';
import isRequired from '../../helpers/decorator';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-input-text',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.css']
})
export class InputTextComponent implements OnInit, OnDestroy {

  @isRequired()
  @Input() fg: FormGroup
  @isRequired()
  @Input() fcn: string
  @Input() className: string
  @Input() placeholder: string
  @Input() isPassword: boolean
  @Input() autoComplete: string
  @Input() type: string
  @Input() value: any
  @Input() title: any
  @Input() id: any

  @Input() minDate: Date
  @Input() maxDate: Date

  @Input() editDate: boolean

  readonly: boolean
  subscribe = new Subject<void>()
  minLength: {}
  show: boolean = false;
  constructor(private translate: TranslateService) { }

  ngOnInit() {
    this.readonly = !this.fcn;
    var ss = this.fcn;

    this.className = "form-control";
    this.mainTask();
    this.show = true;

  }
  mainTask() {
    this.fg.get(this.fcn).valueChanges
      .pipe(takeUntil(this.subscribe))
      .subscribe(_res => {
        var err = this.fg.get(this.fcn).errors;
        var minLengthErr = err ? err.minlength : '';
        this.minLength = { key: ':len', value: minLengthErr ? minLengthErr.requiredLength : '' }
      })
  }
  onClick() {
    this.readonly = false
  }
  ngOnDestroy() {
    this.subscribe.next()
    this.subscribe.unsubscribe()
  }
}
